import angular from 'angular';
import uiRouter from 'angular-ui-router';
import locationFiltersComponent from './locationFilters.component';
import LocationFiltersService from './locationFilters.service';

let locationFiltersModule = angular.module('locationFilters', [
  uiRouter
])

.component('locationFilters', locationFiltersComponent)
.service('LocationFiltersService', LocationFiltersService)

.name;

export default locationFiltersModule;
